import { render, staticRenderFns } from "./header.vue?vue&type=template&id=03b815be"
import script from "./header.vue?vue&type=script&lang=babel"
export * from "./header.vue?vue&type=script&lang=babel"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports